import React from "react";
import CustomCard from "../CustomCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Titled card wrapper used as the first section of a summary recap (icon +
 * title header followed by arbitrary children). Shared by every module's
 * Summary screen.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.icon - Header icon component.
 * @param {string} props.title - Header title text (already translated).
 * @param {React.ReactNode} props.children - Section body.
 * @returns {JSX.Element}
 */
const SummarySection = ({ icon: Icon, title, children }) => (
    <CustomCard className="p-3" classes="card-border-8px" classContent="p-0 overflow-hidden">
        <div className="d-flex align-items-center p-3">
            <div><Icon /></div>
            <div className="ml-2">
                <p className="font-color-general-950 ibl-font-w-600 fs-14px">{title}</p>
            </div>
        </div>
        <div className="border-bottom-shades-300" />
        {children}
    </CustomCard>
);

export default SummarySection
